import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GoodRecord, DataService } from '@core/services/data.service';
import { NumberInputComponent } from '@common/UI/number-input/number-input.component';
import { SynchronizationService } from '@core/services/synchronization.service';
import { ApiService } from '@core/services/api.service';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './good-editor.component.html',
  styleUrls: ['./good-editor.component.scss']
})
export class GoodEditorComponent implements OnInit {

  @Input()
  public good: GoodRecord;

  @Output()
  public onSplitted = new EventEmitter<GoodRecord>();

  public get loading(): boolean {
    return !this.sync.ready(ApiService);
  }

  public splitted: number = 0;

  public get valid(): boolean {
    return this.splitted < this.good.ImportQuoteQuantity && this.splitted > 0;
  }

  public setSplitted(input: NumberInputComponent) {
    if (isNaN(input.value)) input.value = 0;

    this.splitted = input.value = Math.max(0, Math.min(this.good.ImportQuoteQuantity, input.value));
  }

  public setOriginal(input: NumberInputComponent) {
    if (isNaN(input.value)) input.value = this.good.ActualQuantity;
    input.value = Math.max(this.good.ActualQuantity - this.good.ImportQuoteQuantity, Math.min(this.good.ActualQuantity, input.value));
    this.splitted = this.good.ActualQuantity - input.value;
  }

  constructor(private sync: SynchronizationService, private ds: DataService, private modal: ModalService) { }

  ngOnInit(): void {
  }

  public save() {
    this.ds.goods('split', { ID: this.good.ID, ActualQuantity: this.splitted }).subscribe(goods => {
      if (goods && goods.length == 1) {
        this.onSplitted.emit(goods[0]);
        this.modal.of(this).hide();
      }
    });
  }
}
